import React, { PropsWithChildren } from "react";
//#region types
import { ViewPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import ViewPanelOuter from "./viewPanelOuter";
import ViewPanelTitle from "./viewPanelTitle";
import ViewPanelContent from "./viewPanelContent";
import { ErrorBoundary } from "components/error";
//#endregion

const ViewPanel: React.FC<PropsWithChildren<ViewPanelProps>> = (props) => {
  return (
    <ViewPanelOuter
      appearance={props.appearance}
      gridSize={props.gridSize}
      fitContent={props.fitContent}
      className={props.className}
    >
      {props.title && (
        <ViewPanelTitle
          icon={props.icon}
          title={props.title}
          description={props.gridSize === "lg" ? props.description : undefined}
          topRightContent={props.topRightContent}
          additionalContent={props.additionalContent}
        ></ViewPanelTitle>
      )}
      <ErrorBoundary>
        <ViewPanelContent
          elementId={props.elementId}
          isCanvasContent={props.isCanvasContent}
          classes={props.classes}
          footerLeftContent={props.footerLeftContent}
          footerRightContent={props.footerRightContent}
        >
          {props.children}
        </ViewPanelContent>
      </ErrorBoundary>
    </ViewPanelOuter>
  );
};

export default ViewPanel;
